module.exports = __webpack_public_path__ + "img/10.926290a3.jpg";